module.exports = __webpack_public_path__ + "img/logo.a920803f.png";